module.exports = __webpack_public_path__ + "img/marker-user.caeba019.svg";